import { memo, useEffect } from "react";
import { useContent } from "../../../../../../../contexts/contentContext/contentContext";
import { useParams } from "react-router-dom";
import type { PackageTypeRouteT } from "../../../../models/models";
import useCurrency from "../../../../hooks/useCurrency";
import { CurrencySymbolE } from "../../../../models/enums";
import usePurchases from "../../../../hooks/usePurchases";
import useAddon from "../../../../hooks/useAddon";

import styles from "./styles.module.scss";

const AddonPriceDetails = memo(() => {
  const { packageType } = useParams<{
    packageType: PackageTypeRouteT;
  }>();
  const { getTextByKey } = useContent();
  const { currency } = useCurrency();
  const { fetchPurchasePrice, purchasePrice } = usePurchases();
  const { addonQuantity, addonData } = useAddon();

  const billingCyclePrice = addonData!?.[currency] * addonQuantity;

  useEffect(() => {
    fetchPurchasePrice(packageType!);
  }, [fetchPurchasePrice, packageType]);

  return (
    <div className={styles.purchaseDetailsPrice}>
      <div className={styles.featureQuantity}>
        <div className={styles.featureQuantityText}>
          {getTextByKey(`feature-quantity-${packageType}`)}
        </div>
        <div className={styles.featureQuantityValue}>
          {addonQuantity}
          {packageType === "extra-storage" ? "TB" : ""}
        </div>
      </div>
      {purchasePrice < billingCyclePrice ? (
        <div className={styles.currentPrice}>
          <div className={styles.currentPriceText}>
            {getTextByKey("purchase-per-today")}
          </div>
          <div className={styles.currentPriceValue}>
            {CurrencySymbolE[currency]} {purchasePrice.toFixed(2)}
          </div>
        </div>
      ) : null}
      <div className={styles.nextPrice}>
        <div>
          {getTextByKey(
            packageType === "extra-storage" || packageType === "sub-users"
              ? "billing-price-addon"
              : "next-billing-price"
          )}
        </div>
        <div>
          {CurrencySymbolE[currency]}{" "}
          {addonQuantity > 0 ? billingCyclePrice.toFixed(2) : 0}
        </div>
      </div>
      {purchasePrice < billingCyclePrice && (
        <div className="global-text-purchase">
          {getTextByKey("purhcase-feature-calculate-text")}
        </div>
      )}
      {packageType !== "extra-storage" && packageType !== "sub-users" ? (
        <div>{getTextByKey("purhcase-feature-calculate-text")}</div>
      ) : null}
    </div>
  );
});

export default AddonPriceDetails;
